import { render, staticRenderFns } from "./modalReceita.vue?vue&type=template&id=0393da6a&"
import script from "./modalReceita.vue?vue&type=script&lang=js&"
export * from "./modalReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports